export default "__VITE_ASSET__df78ee71__"